import React, { useContext, useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import * as actionType from "../context/actions";
import DeleteInvoiceView from "./DeleteInvoiceView";
import PaginationView from "./PaginationView";
import { FilterdData } from "../helper/FilterdData";
import DataNotFoundView from "./DataNotFoundView";
import { useNavigate } from "react-router-dom";
import { Languages } from "../Utils/Languages";
import { PremiumFeatureOnlyModal } from "./PremiumFeatureOnlyModal";
import { FreePlanLimitReachedModal } from "./FreePlanLimitReached";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { DownloadDocument } from "./preview/previewaction";
import { resolveAuditName } from "../Utils/audit_helper";
import LoaderView from "./LoaderView";
import { AddInvoice } from "../data";
import { toast } from "react-toastify";
import Currancy from "../Utils/currency.json";


const InvoiceTableDataLayer = ({ InvoicesData, selectedBusiness }) => {
    const navigate = useNavigate();
    const { state, dispatch } = useContext(ConfigContext);
    const [filterdInvoiceData, setFilterdInvoiceData] = useState(InvoicesData);
    const [enrichedInvoices, setEnrichedInvoices] = useState([]);
    const [isDisplayPrimiumFeatureModel, setIsDisplayPrimiumFeatureModel] = useState(false)
    const [isDisplayFreePlanReachedModel, setIsDisplayFreePlanReachedModel] = useState(false);
    const [limitPlanName, setLimitPlanName] = useState("Free Plan");
    const [limitValue, setLimitValue] = useState(2);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(false);

    const handleDownloadInvoice = (invoiceId) => {
        dispatch({
            type: actionType.SELECTEDINVOICE,
            payload: invoiceId
        });

        navigate("/invoice-preview?download=true");
    };
    const handlePrintInvoice = (invoiceId) => {
        dispatch({
            type: actionType.SELECTEDINVOICE,
            payload: invoiceId
        });
        navigate("/invoice-preview?print=true");
    };
    // Enhanced function to enrich invoice data for better search
    const enrichInvoiceData = (invoices) => {
        return invoices.map((invoice, index) => {
            // Find customer name
            const matchedCustomer = state?.CUSTOMERS?.find(
                (cust) => cust.customerId?.toString() === invoice.customerId?.toString()
            );
            const customerName = matchedCustomer?.customer || "Unknown";

            // Format issued date safely
            let issuedDate = "";
            try {
                const rawDate = invoice.date;
                if (rawDate) {
                    let ts = parseInt(rawDate);
                    if (!isNaN(ts)) {
                        if (ts.toString().length <= 10) ts *= 1000;
                        const d = new Date(ts);
                        if (!isNaN(d.getTime())) {
                            issuedDate = d.toDateString();
                        }
                    }
                }
            } catch (e) {
                issuedDate = "";
            }

            // Format status
            const paidStatus = (invoice.paidFlagKey === "true" || invoice.paidFlagKey === true)
                ? Languages[state?.LANGUAGE]?.paid || "Paid"
                : Languages[state?.LANGUAGE]?.unpaid || "Unpaid";

            // Calculate due status
            let dueStatus = "No Due Date";
            if (invoice.dueDate) {
                let dueDateNum = parseInt(invoice.dueDate);
                if (dueDateNum.toString().length === 10) {
                    dueDateNum = dueDateNum * 1000;
                }
                const dueDate = new Date(dueDateNum);
                const today = new Date();
                dueDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const diffTime = dueDate.getTime() - today.getTime();
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays === 0) {
                    dueStatus = "Due Today";
                } else if (diffDays < 0) {
                    dueStatus = `Overdue ${Math.abs(diffDays)} ${Math.abs(diffDays) === 1 ? "day" : "days"}`;
                } else {
                    dueStatus = `Due in ${diffDays} ${diffDays === 1 ? "day" : "days"}`;
                }
            }

            return {
                ...invoice,
                srNo: index + 1,
                customerName, // Add searchable customer name
                issuedDateFormatted: issuedDate, // Add searchable formatted date
                paidStatusText: paidStatus, // Add searchable status text
                dueStatusText: dueStatus // Add searchable due status text
            };
        });
    };

    useEffect(() => {
        setFilterdInvoiceData(FilterdData(state, InvoicesData, "date"));
    }, [state])
    const matchedInvoices = useMemo(() => {
        const filteredData = (selectedBusiness === null || selectedBusiness === "null")
            ? filterdInvoiceData
            : filterdInvoiceData.filter(invoice => invoice?.companyId == selectedBusiness);

        return enrichInvoiceData(filteredData);
    }, [filterdInvoiceData, selectedBusiness, state?.CUSTOMERS, state?.LANGUAGE]);
    const totalPages = Math.ceil(matchedInvoices?.length / itemsPerPage);

    useEffect(() => {
        // Select all elements with data-bs-toggle="DefaultTooltipThree"
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="DefaultTooltipThree"]');
        // Initialize tooltips
        const tooltipList = Array.from(tooltipTriggerList).map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );
        // Cleanup on unmount
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, []);

    useEffect(() => {
        if (state?.CUSTOMERS && Array.isArray(InvoicesData)) {
            const enriched = InvoicesData.map((invoice) => {
                const matchedCustomer = state.CUSTOMERS.find(
                    (cust) => cust.customerId === invoice.customerId
                );

                return {
                    ...invoice,
                    customerName: matchedCustomer?.customer || "Unknown",
                };
            });

            setEnrichedInvoices(enriched);
        }
    }, [state?.CUSTOMERS, InvoicesData]);

    // Pagination logic
    // const paginatedData = useMemo(() => {
    //     const start = (currentPage - 1) * itemsPerPage;
    //     return matchedInvoices.slice(start, start + itemsPerPage);
    // }, [matchedInvoices, currentPage, itemsPerPage]);

    // Ensure currentPage is always valid
    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage]);

    const sortCaret = (order, column) => {
        return (
            <span className="d-inline-flex align-items-center ms-2" >
                {!order ? (
                    <Icon icon="mdi:swap-vertical" className="text-muted" />
                ) : order === "asc" ? (
                    <Icon icon="mdi:arrow-up-thick" className="text-muted" />
                ) : (
                    <Icon icon="mdi:arrow-down-thick" className="text-muted" />
                )}
            </span>
        );
    };


    const { SearchBar } = Search;
    const isPremium = state?.PREMIUM;

    const handleWhatsappInvoice = (invoiceId) => {
        dispatch({
            type: actionType.SELECTEDINVOICE,
            payload: invoiceId
        });

        navigate("/invoice-preview?whatsapp=true");
    };

    const handleShareInvoice = (invoiceId) => {
        dispatch({
            type: actionType.SELECTEDINVOICE,
            payload: invoiceId
        });

        navigate("/invoice-preview?share=true");
    };

    function incrementLastPart(str) {
        const match = str?.match(/^(.*?)(\d+|[a-zA-Z])$/);
        if (!match) return str + "1"; // fallback
        const prefix = match[1];
        const lastPart = match[2];
        if (!isNaN(lastPart)) {
            const incremented = (parseInt(lastPart) + 1)?.toString();
            return prefix + incremented;
        }
        const charCode = lastPart?.charCodeAt(0);
        let nextChar;
        if (lastPart >= 'a' && lastPart <= 'z') {
            nextChar = String.fromCharCode(charCode === 122 ? 97 : charCode + 1);
        } else if (lastPart >= 'A' && lastPart <= 'Z') {
            nextChar = String.fromCharCode(charCode === 90 ? 65 : charCode + 1);
        } else {
            nextChar = lastPart;
        }
        return prefix + nextChar;
    }

    const handleDuplicate = (row) => {
        try {
            const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
            const isSharedRow = business?.isShared === true;
            const targetUid = isSharedRow ? business?.ownerUid : null;

            // Generate unique internal ID
            const newInvoiceUid = Date.now().toString() + Math.floor(Math.random() * 1000);

            // Generate unique ID (Serial Number) - Case Insensitive Check
            let newId = incrementLastPart(String(row.id));
            const allExistingIds = [
                ...(state?.INVOICES || []).map(inv => String(inv.id).toLowerCase()),
                ...(state?.PROFORMAINVOICES || []).map(inv => String(inv.id).toLowerCase()),
                ...(state?.QUOTATION || []).map(inv => String(inv.id).toLowerCase())
            ];

            while (allExistingIds.includes(newId.toLowerCase())) {
                newId = incrementLastPart(newId);
            }

            // Generate unique customInvoiceId if it exists - Case Insensitive Check
            let newCustomInvoiceId = row.customInvoiceId ? incrementLastPart(String(row.customInvoiceId)) : newId;
            const allExistingCustomIds = [
                ...((state?.INVOICES || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase())),
                ...((state?.PROFORMAINVOICES || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase())),
                ...((state?.QUOTATION || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase()))
            ];

            if (row.customInvoiceId) {
                while (allExistingCustomIds.includes(newCustomInvoiceId.toLowerCase())) {
                    newCustomInvoiceId = incrementLastPart(newCustomInvoiceId);
                }
            }

            const duplicatedInvoice = {
                ...row,
                id: newId,
                invoiceId: newInvoiceUid,
                date: Date.now().toString(),
                creationDate: Date.now().toString(),
                customInvoiceId: newCustomInvoiceId,
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                paidFlagKey: "false", // Reset payment status for duplicate
                paymentHistory: [],
                dueAmount: row.totalAmount, // Reset due amount to total
                paidAmount: "0"
            };

            // Remove Firebase specific ID
            delete duplicatedInvoice.uniqueID;

            AddInvoice(state, dispatch, duplicatedInvoice, targetUid);
            toast.success("Invoice duplicated successfully");
        } catch (error) {
            console.error("Duplicate Invoice error:", error);
            toast.error("Failed to duplicate Invoice.");
        }
    };

    const columns = [
        {
            dataField: "srNo",
            text: Languages[state?.LANGUAGE]?.s_r,
            headerAlign: "center",
            align: "center",
            sort: true,
            formatter: (cell) => (
                <span style={{ marginLeft: -8 }}>{cell}</span>
            ),
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "customInvoiceId",
            text: Languages[state?.LANGUAGE]?.invoice_no,
            headerAlign: "center",
            align: "center",
            sort: true,
            formatter: (cell, row) => {
                const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                const isShared = business?.isShared === true;

                const currentUserStr = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";
                const resolvedName = resolveAuditName(row.createdBy, state.membersData);
                const creatorName = (resolvedName === "Unknown" && business?.ownerName)
                    ? business.ownerName
                    : resolvedName;
                const isCreator = creatorName === currentUserStr || row.createdBy === currentUserStr || (typeof row.createdBy === 'object' && row.createdBy?.uid === state?.USERID);

                const showByLabel = row.createdBy
                    ? !isCreator
                    : (isShared && business?.ownerName); // fallback: show owner if no createdBy but it's shared

                const displayName = row.createdBy
                    ? creatorName
                    : business?.ownerName;

                return (
                    <div style={{ marginLeft: -8 }}>
                        <div>{cell && cell.trim() !== "" ? cell : row?.id}</div>
                        {showByLabel && (
                            <small className="text-secondary-light" style={{ fontSize: '11px', display: 'block', marginTop: '-4px' }}>
                                by: {displayName}
                            </small>
                        )}
                    </div>
                );
            },
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "customerName", // Now using the enriched customerName field
            text: Languages[state?.LANGUAGE]?.customer_name,
            sort: true,
            style: { minWidth: "150px" },
            sortCaret: sortCaret,
            formatter: (cell) => (
                <span style={{ marginLeft: -8 }}>{cell || "Unknown"}</span>
            ),
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "totalAmount",
            text: Languages[state?.LANGUAGE]?.amount,
            sort: true,
            sortCaret: sortCaret,
            formatter: (cell, row) => {
                const matchedCurrency = row?.currency ? Currancy.CountryCurrencyResponse.find(
                    (c) => c.currencyCode === row.currency
                ) : null;
                const currencyCode = matchedCurrency ? matchedCurrency.currencyCode : state?.CURRENCYCODE;
                const currencySymbol = matchedCurrency ? matchedCurrency.currencytSymbol : state?.SYMBOL;
                return (
                    <span>{currencySymbol === "$" ? `${currencyCode} ${currencySymbol} ` : `${currencySymbol} `} {cell}</span>
                );
            },
            sortFunc: (a, b, order) => {
                if (order === 'asc') {
                    return Number(a) - Number(b);
                }
                return Number(b) - Number(a);
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "issuedDateFormatted", // Using the enriched formatted date for search
            text: Languages[state?.LANGUAGE]?.issued_date,
            formatter: (cell) => cell, // Data is already formatted
            sort: true,
            style: { minWidth: "100px" },
            sortCaret: sortCaret,
            sortFunc: (a, b, order) => {
                // Sort by original timestamp for proper chronological order
                const dateA = new Date(a);
                const dateB = new Date(b);
                if (order === 'asc') {
                    return dateA - dateB;
                }
                return dateB - dateA;
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "paidStatusText", // Using enriched status text for search
            text: Languages[state?.LANGUAGE]?.status,
            headerAlign: "center",
            align: "center",
            formatter: (cell, row) => (
                <span
                    className={`d-inline-block text-center px-24 py-4 rounded-pill fw-medium text-sm ${(row.paidFlagKey === "true" || row.paidFlagKey == true) ? "bg-success-focus text-success-main" : "bg-danger-focus text-danger-main"
                        }`}
                >
                    {cell}
                </span>
            ),
            sort: true,
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "dueStatusText", // Using enriched due status for search
            text: "Due Status",
            headerAlign: "center",
            align: "center",
            formatter: (cell, row) => {
                if (!row.dueDate) {
                    return (
                        <span className="d-inline-block text-center px-24 py-4 rounded-pill fw-medium text-sm bg-danger-focus text-danger-main">
                            No Due Date
                        </span>
                    );
                }

                let dueDateNum = parseInt(row.dueDate);
                if (dueDateNum.toString().length === 10) {
                    dueDateNum = dueDateNum * 1000;
                }

                const dueDate = new Date(dueDateNum);
                const today = new Date();
                dueDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const diffTime = dueDate.getTime() - today.getTime();
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                const isToday = diffDays === 0;
                const isOverdue = diffDays < 0;

                if (isToday) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-warning-focus text-warning-main">
                            Due Today
                        </span>
                    );
                } else if (isOverdue) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-danger-focus text-danger-main">
                            {Math.abs(diffDays)} {Math.abs(diffDays) === 1 ? "day" : "days"}
                        </span>
                    );
                } else {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-success-focus text-success-main">
                            {diffDays} {diffDays === 1 ? "day" : "days"}
                        </span>
                    );
                }
            },
            sort: true,
            sortCaret: sortCaret,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    OnClickOfRow(row?.invoiceId, row?.paidFlagKey);
                }
            }
        },
        {
            dataField: "action",
            text: Languages[state?.LANGUAGE]?.action,
            headerAlign: "center",
            align: "center",
            searchable: false, // Exclude action column from search
            formatter: (cell, row) => {
                const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                const isShared = business?.isShared === true;
                const canAccessSalesReturn = isPremium || isShared;

                return (
                    <>
                        <Link
                            onClick={(e) => {
                                if (!state?.USERID) {
                                    e.preventDefault();
                                    dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                    return;
                                }
                                dispatch({ type: actionType.SELECTEDINVOICE, payload: row?.invoiceId });
                            }}
                            to="/invoice-preview"
                            className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-primary"
                            data-bs-title="View Invoice"
                        >
                            <Icon icon="iconamoon:eye-light" />
                        </Link>
                        <Link
                            onClick={(e) => {
                                if (!state?.USERID) {
                                    e.preventDefault();
                                    dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                    return;
                                }
                                dispatch({ type: actionType.SELECTEDINVOICE, payload: row?.invoiceId });
                            }}
                            to="/invoice-edit"
                            className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-success"
                            data-bs-title="Edit Invoice"
                        >
                            <Icon icon="lucide:edit" />
                        </Link>

                        <Link
                            onClick={(e) => {
                                if (!state?.USERID) {
                                    e.preventDefault();
                                    dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                    return;
                                }
                                const currentYear = new Date().getFullYear();
                                const currentMonth = new Date().getMonth();
                                const freePlanLimit = Number(process.env.REACT_APP_FREE_PLAN_INVOICE_LIMIT || 2);

                                const currentMonthSalesReturn = (state?.SALERETURN || []).filter(sr => {
                                    const biz = state?.BUSINESSES?.find(b => String(b.companyId) === String(sr.companyId));
                                    if (biz?.isShared) return false;
                                    const date = new Date(Number(sr.creationDate));
                                    return date.getFullYear() === currentYear && date.getMonth() === currentMonth;
                                }).length;

                                const userPlanName = state?.PAYMENT?.[state?.PAYMENT?.length - 1]?.planName || "Free Plan";
                                const isFreePlan = userPlanName === "Free Plan";
                                const isExistingReturn = state?.SALERETURN?.some(returnItem => returnItem.invoiceId === row?.invoiceId);

                                const business_shared = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                                const isShared_row = business_shared?.isShared === true;

                                // ✅ If not premium and not a shared business, block access
                                if (!isPremium && !isShared_row) {
                                    e.preventDefault();
                                    setIsDisplayPrimiumFeatureModel(true);
                                    return;
                                }

                                if (!isExistingReturn && isFreePlan && !isPremium && !isShared_row && currentMonthSalesReturn >= freePlanLimit) {
                                    e.preventDefault();
                                    setLimitPlanName("Free Plan");
                                    setLimitValue(freePlanLimit);
                                    setIsDisplayFreePlanReachedModel(true);
                                    return;
                                }

                                if (!isPremium && !isShared_row && !isFreePlan) {
                                    setLimitValue(freePlanLimit);
                                    setIsDisplayFreePlanReachedModel(true);
                                }

                                if (!isPremium && !isShared_row && isFreePlan && !isExistingReturn && currentMonthSalesReturn >= freePlanLimit) {
                                    // Handled above
                                } else if (!isPremium && !isShared_row && !isFreePlan) {
                                    // Handle starter or others if they have specific limits for sales return
                                    // Based on previous patterns, we only block Free users or show premium modal if it's a locked feature.
                                }

                                dispatch({ type: actionType.SELECTEDINVOICE, payload: row?.invoiceId });
                            }}
                            to={state?.SALERETURN?.some(returnItem => returnItem.invoiceId === row?.invoiceId) ? "/sales-return-edit" : "/sales-return-add"}
                            className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-primary"
                            data-bs-title="Sales Return"
                        >
                            <Icon icon="lsicon:sales-return-outline" />
                        </Link>
                        <Link
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-danger"
                            data-bs-title="Delete Invoice"
                        >
                            <DeleteInvoiceView FirebaseId={row?.uniqueID} />
                        </Link>
                        <Link
                            onClick={(e) => {
                                if (!state?.USERID) {
                                    e.preventDefault();
                                    dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                    return;
                                }
                                handleDuplicate(row);
                            }}
                            className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            data-bs-toggle="DefaultTooltipThree"
                            data-bs-placement="top"
                            data-bs-custom-class="tooltip-info"
                            data-bs-title="Duplicate Invoice"
                        >
                            <Icon icon="lucide:copy" />
                        </Link>
                    </>
                );
            },
        }
    ];

    const OnClickOfRow = (invoiceId, isPaid) => {
        if (!state?.USERID) {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
            return;
        }
        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoiceId })
        if (isPaid == "true" || isPaid == true) {
            navigate("/invoice-preview")
        }
        else {
            navigate("/invoice-edit")
        }
    }

    const handleSelection = (val) => {
        setItemsPerPage(val)
        setCurrentPage(1)
    };

    return (
        <div className="card">
            <div className="card-body">
                <ToolkitProvider
                    keyField="uniqueID"
                    data={matchedInvoices} // all invoices
                    columns={columns}
                    search
                >
                    {props => {
                        // Get current search text
                        const searchText = props.searchProps.searchText?.toLowerCase() || "";

                        // Filter full matchedInvoices based on search
                        const filteredData = matchedInvoices.filter(invoice => {
                            return (
                                invoice.customInvoiceId?.toString()?.toLowerCase().includes(searchText) ||  // ✅ ADD THIS
                                invoice.invoiceId?.toString()?.toLowerCase().includes(searchText) ||
                                invoice.customerName?.toLowerCase().includes(searchText) ||
                                invoice.issuedDateFormatted?.toLowerCase().includes(searchText) ||
                                invoice.paidStatusText?.toLowerCase().includes(searchText) ||
                                invoice.dueStatusText?.toLowerCase().includes(searchText) ||
                                invoice.totalAmount?.toString()?.toLowerCase().includes(searchText)
                            );
                        });

                        // Apply pagination AFTER search
                        const start = (currentPage - 1) * itemsPerPage;
                        const paginatedSearchData = filteredData.slice(start, start + itemsPerPage);

                        return (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <SearchBar
                                        {...props.searchProps}
                                        placeholder={Languages[state?.LANGUAGE]?.search_invoices}
                                        className="form-control w-auto"
                                    />
                                </div>
                                <div className="table-responsive">
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        bordered={false}
                                        data={paginatedSearchData} // use paginated filtered data
                                        wrapperClasses={`custom-table-border invoice-table ${localStorage.getItem("theme") == "dark" ? "table-dark" : "table-light"}`}
                                        defaultSorted={{
                                            dataField: "date",
                                            order: "desc",
                                        }}
                                        noDataIndication={() => <DataNotFoundView height={400} />}
                                        rowStyle={{ cursor: "pointer" }}
                                    />
                                </div>

                                {filteredData.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="d-flex align-items-center gap-2 entry_per_page">
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-outline-primary-600 not-active px-18 py-6 dropdown-toggle toggle-icon"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {itemsPerPage}
                                                </button>
                                                <ul className="dropdown-menu shadow-md">
                                                    {[5, 10, 15, 20].map((value) => (
                                                        <li key={value}>
                                                            <Link
                                                                className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${itemsPerPage == value && "bg-primary-50"
                                                                    }`}
                                                                onClick={() => handleSelection(value)}
                                                            >
                                                                {value}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-secondary-light">
                                                {Languages[state?.LANGUAGE]?.entries_per_page}
                                            </span>
                                        </div>

                                        <div className="ms-auto">
                                            <PaginationView
                                                currentPage={currentPage}
                                                totalPages={Math.ceil(filteredData.length / itemsPerPage)} // 👈 based on search results
                                                handlePageChange={setCurrentPage}
                                            />
                                        </div>
                                        {/* <PaginationView
                                            currentPage={currentPage}
                                            totalPages={Math.ceil(filteredData.length / itemsPerPage)}
                                            handlePageChange={setCurrentPage}
                                        /> */}
                                    </div>
                                )}
                            </>
                        );
                    }}
                </ToolkitProvider>
                {isLoading && <LoaderView />}
                <PremiumFeatureOnlyModal
                    isOpen={isDisplayPrimiumFeatureModel}
                    onClose={() => setIsDisplayPrimiumFeatureModel(false)}
                />
                <FreePlanLimitReachedModal
                    isOpen={isDisplayFreePlanReachedModel}
                    onClose={() => setIsDisplayFreePlanReachedModel(false)}
                    limit={limitValue}
                    type="Sales Return"
                    planName={limitPlanName}
                />
            </div>
        </div>
    );
};

export default InvoiceTableDataLayer;